import { useEffect, useState } from 'react';
import { getFeatureFlag } from '../api';

/**
 * Checks for a localstorage feature flag override
 * Used for development/QA only!
 *
 * force enabled -> window.localStorage.setItem('opendoor.reception.exclusive-offers', true)
 * force disabled -> window.localStorage.setItem('opendoor.reception.exclusive-offers', false)
 */
export const getLocalFeatureFlagOverrides = (featureFlag: string) => {
  if (
    // Ignore override check on the server
    typeof window !== 'undefined' &&
    window.localStorage.getItem(`opendoor.cosmos.${featureFlag}`) === 'true'
  ) {
    return true;
  }

  return false;
};

/**
 * Hook returning if a specific feature flag is enabled in Optimizely.
 * (Optimizely project: [Seller [formerly Marketing Infra]](https://app.optimizely.com/v2/projects/15794150625/features)
 *
 * @param {string} featureName Name of the feature flag
 * @param {boolean} defaultValue Value to use while the feature flag is loading
 * @returns {boolean} `true` if enabled, `false` if not
 */
export const useFeatureFlag = (
  featureName: string,
  options?: {
    defaultValue?: boolean | null;
    market?: string;
  },
): boolean | null => {
  const [featureFlagEnabled, setFeatureFlagEnabled] = useState<boolean | null>(
    options?.defaultValue !== undefined ? options.defaultValue : false,
  );

  useEffect(() => {
    getFeatureFlag(featureName, options?.market)
      .then((result) => {
        if (
          result &&
          result.data &&
          result.data.external &&
          result.data.external.optimizely &&
          result.data.external.optimizely.featureFlags &&
          result.data.external.optimizely.featureFlags.length > 0
        ) {
          setFeatureFlagEnabled(result.data.external.optimizely.featureFlags[0].enabled);
        }

        if (result.errors) {
          setFeatureFlagEnabled(false);
        }
      })
      .catch(() => setFeatureFlagEnabled(false));
  }, [featureName]);

  return featureFlagEnabled;
};
